import { selectIsAccountOwner } from "@app/deploy";
import { selectOrganizationSelectedId } from "@app/organizations";
import { useSelector } from "@app/react";
import { teamManagedAiUrl } from "@app/routes";
import { Link } from "react-router-dom";

/** Only account owners can edit the organization's policy on Managed AI settings. */
export const EditPolicyLink = () => {
  const orgId = useSelector(selectOrganizationSelectedId);
  const isAccountOwner = useSelector((s) => selectIsAccountOwner(s, { orgId }));

  if (!isAccountOwner) return null;

  return (
    <Link to={teamManagedAiUrl()} className="underline">
      Edit policy
    </Link>
  );
};
